import {
  Box,
  Button,
  Flex,
  Text,
} from "@chakra-ui/react";

type UpdatePromptProps = {
  onUpdate: () => void;
};

export function UpdatePrompt({ onUpdate }: UpdatePromptProps) {
  return (
    <Box
      position="fixed"
      left={4}
      right={4}
      bottom={4}
      zIndex={2000}
      bg="barber.800"
      border="1px solid"
      borderColor="whiteAlpha.200"
      borderRadius="xl"
      px={4}
      py={4}
      boxShadow="lg"
      style={{
        paddingBottom: "calc(1rem + env(safe-area-inset-bottom))",
      }}
    >
      <Flex
        direction={{ base: "column", sm: "row" }}
        align={{ base: "stretch", sm: "center" }}
        justify="space-between"
        gap={3}
      >
        <Text color="white" fontSize="sm">
          Uma nova versão do Meu Barbeiro PRO está disponível.
        </Text>
        <Button
          size="sm"
          bg="button.cta"
          color="black"
          flexShrink={0}
          _hover={{ opacity: 0.85 }}
          onClick={onUpdate}
        >
          Atualizar agora
        </Button>
      </Flex>
    </Box>
  );
}
